import comp from "./ModuleAccessInfoPopup";
export default comp;
